export default __webpack_public_path__ + "static/media/ubr_profile.8edbba29.svg";